export const PROCESSING_ASYNC_DATA = 'PROCESSING_ASYNC_DATA';
export const UPDATE_SCHEDULER_SQUAD_COUNT = 'UPDATE_SCHEDULER_SQUAD_COUNT';
export const UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT = 'UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT';
export const CLEAR_SCHEDULER_ITEMS = 'CLEAR_SCHEDULER_ITEMS';

// constants for enumerating virtual event owner
export const TEAM_ENTRY = "Team Entry";
export const BOWLER = "Bowler";



// WEBPACK FOOTER //
// ./src/features/shared/constants.js